module.exports = __webpack_public_path__ + "static/assets/439cddb83c09b2be056ed9587a26ccf6.png";